module.exports = __webpack_public_path__ + "static/media/praca-czasowa-on.8684c8c1.svg";